import { render, staticRenderFns } from "./PmcPopup.vue?vue&type=template&id=713306c4&scoped=true&"
import script from "./PmcPopup.vue?vue&type=script&lang=js&"
export * from "./PmcPopup.vue?vue&type=script&lang=js&"
import style0 from "./PmcPopup.vue?vue&type=style&index=0&id=713306c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713306c4",
  null
  
)

export default component.exports